<script lang="ts">
	import ReadMore from '$lib/components/ui/ReadMore.svelte';
	import TimelineEvents from '$lib/components/ui/TimelineEvents.svelte';
	import type { TimelineEvent } from '$lib/features/timelineEvent/timelineEvent.type';

	const { story, events, storyMaxLines = 7 }: { story: string; events: TimelineEvent[]; storyMaxLines?: number } = $props();
</script>

<div id="history" class="flex flex-col gap-6">
	<ReadMore text={story} class="max-w-none leading-relaxed text-base-content/80" maxLines={storyMaxLines} />

	{#if events.length > 0}
		<div class="pt-2">
			<TimelineEvents timelineEvents={events} />
		</div>
	{/if}
</div>
